<template>
  <mdb-container fluid>
    <DataTableAG
      v-if="loadReady"
      deleteparam="advertisementids"
      :columns="columns"
      width="1860px"
      height="750px"
      archivecontentpath="2.0/newbe/deleteadvertisements"
      archiveparam="advertisementids"
      :getcontentpath="getcontentpath"
      :buttonList="['Muokkaa', 'Esikatselu', 'Kopioi']"
      jsonobject="advertisements"
      :image="true"
      v-on:pressed-button1="editAdvertisement"
      v-on:pressed-button2="previewAdvertisement"
      v-on:pressed-button3="copyAdvertisement"
      :rowHeight="120"
      deleteEnabled
      :newBenefitCategoryId="newBenefitCategoryId"
    />
  </mdb-container>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbContainer } from "mdbvue";

export default {
  name: "Advertisements",
  components: {
    DataTableAG,
    mdbContainer,
  },
  props: {
    ismobilepayspecific: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    getadvertisementspath: "/1.0/front/advertisements",
    getmobilepayadvertisementspath: "/1.0/front/advertisements?mobilepayspecific=1&sessionid=",
    categoriespath: "/1.0/front/categories",
    getcontentpath: "",
    newBenefitCategoryId: undefined,
    loadReady: false,

    columns: [
      {
        field: "partner_id",
        headerName: "Liittokohdistus",
        width: 100,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "title",
        headerName: "Otsikko",
        width: 200,
        sortable: true,
        filter: true,
        resizable: true,
      },
      
      {
        field: "image",
        headerName: "Kuva",
        width: 180,
        sortable: true,
        filter: true,
        resizable: true,
        cellRenderer: "SimpleImageComponent",
      },
      {
        field: "categorylist",
        headerName: "Kategoriat",
        width: 200,
        sortable: true,
        filter: true,
        resizable: true,
        cellRenderer: "SimpleListComponent",
        cellRendererParams: {
          list: "categorylist",
        },
      },
      {
        field: "validfrom",
        headerName: "Voimassa alkaen",
        width: 160,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "validto",
        headerName: "Päättyy",
        width: 160,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "notificationdatetimes",
        headerName: "Ilmoituksen lähetysajat",
        width: 200,
        sortable: true,
        filter: true,
        resizable: true,
        cellRenderer: "SimpleListComponent",
        cellRendererParams: {
          list: "notificationdatetimes",
        },
      },
      {
        field: "archived",
        headerName: "Poistettu",
        width: 120,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "carousel.image",
        headerName: "Karuselli",
        width: 120,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "carousel.validfrom",
        headerName: "Karuselli alkaa",
        width: 160,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "carousel.validto",
        headerName: "Karuselli päättyy",
        width: 160,
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "newBenefit",
        headerName: "Uusi etu",
        width: 120,
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  methods: {
    editAdvertisement(rowData) {
      this.ismobilepayspecific
        ? this.$router.push("/addmobilepayadvertisement/" + rowData.id)
        : this.$router.push("/addadvertisement/" + rowData.id);
    },
    previewAdvertisement(rowData) {
      this.$router.push("/advertisementpreview/" + rowData.id);
    },
    copyAdvertisement(rowData) {
      this.$router.push("/copyadvertisement/" + rowData.id);
    },
  },
  mounted() {
    if(this.ismobilepayspecific) {
      this.getcontentpath = this.getmobilepayadvertisementspath;
    } else {
      this.getcontentpath = this.getadvertisementspath;
    }
    this.$http
      .get(this.categoriespath)
      .then((response) => {
        if (response.status == 200) {
          var index = response.data.categories
            .map(function(e) {
              return e.name;
            })
            .indexOf("UUDETEDUT");
          if (index !== -1) {
            this.newBenefitCategoryId = response.data.categories[index].id;
          }
          this.loadReady = true;
        } else if (response.status == 401) {
          this.$root.$emit("session_failed");
        }
      })
      .catch((error) => {
        this.$root.$emit("session_failed");
        return error;
      });
  },
};
</script>
